import React, { ElementType } from 'react';
import { ListItem, ListItemAvatar, ListItemText, Avatar } from '@mui/material';
import styled from 'styled-components';
import Select from '../common/Select';

const StyledDeviceSelection = styled(ListItem)`
    padding-left: 0px;
    padding-top: 1.25rem;
    padding-bottom: 1.5rem;

    .avatar {
        width: 40px;
        height: 40px;
    }

    .avatar-primary {
        background-color: #00aa55;
    }
    .avatar-default {
        background-color: #646b74;
    }
    .avatar-icon {
        width: 32px;
        height: 32px;
    }

    & .MuiListItemSecondaryAction-root {
        right: 0;
    }

    .secondary-action {
        display: flex;
        align-items: center;
        gap: 0.5rem;
    }

    .select {
        width: 220px !important;
        padding: 10px 14px;
    }
`;

export interface DeviceSelectionProps {
    primaryText: string;
    icon: ElementType;
    value: MediaDeviceInfo | null;
    options: MediaDeviceInfo[];
    onChange: (value: MediaDeviceInfo) => void;
    disabled?: boolean;
    className?: string;
    id?: string;
    extra?: React.ReactNode;
    ariaLabel?: string;
}

const DeviceSelection: React.FC<DeviceSelectionProps> = ({
    primaryText,
    icon: Icon,
    value,
    options,
    onChange,
    disabled,
    extra,
    ariaLabel,
    ...props
}) => {
    const { id } = props;
    return (
        <StyledDeviceSelection
            {...props}
            secondaryAction={
                <div className="secondary-action">
                    <Select
                        className="select"
                        value={value}
                        options={options}
                        getOptionLabel={(option: MediaDeviceInfo) => option.label}
                        getOptionValue={(option: MediaDeviceInfo) => option.deviceId}
                        onChange={onChange}
                        disabled={disabled}
                        data-testid="device-setting-select"
                        id={`${id}-select`}
                        aria-label={ariaLabel}
                    />
                    {extra}
                </div>
            }
        >
            <ListItemAvatar>
                <Avatar className="avatar avatar-default" data-testid="device-setting-avatar">
                    <Icon className="avatar-icon" />
                </Avatar>
            </ListItemAvatar>
            <ListItemText primary={primaryText} data-testid="list-item-text" />
        </StyledDeviceSelection>
    );
};
export default DeviceSelection;
